import { cloneDeep } from 'lodash';

const SET_CART_ERROR = 'SET_CART_ERROR';
const SET_CART_ERROR_FALSE = 'SET_CART_ERROR_FALSE';

const initialStateCartError = false;

export default function reducer(state = cloneDeep(initialStateCartError), action) {
	switch (action.type) {
		case SET_CART_ERROR:
			return action.payload;
		case SET_CART_ERROR_FALSE:
			return false;
		default:
			return state;
	}
}

export function fireCartError( msg ){
  return {
    type: SET_CART_ERROR,
    payload: msg
  }
}

export function clearCartError(){
  return { type: SET_CART_ERROR_FALSE }
}


// WEBPACK FOOTER //
// ./src/modules/cart_error.js